<script>
	import FormRow from "../../../components/FormRow.svelte";
</script>

<FormRow>
	<p>
		By registering with us, you are signing up to receive updates on our investigation into a potential group action
		regarding Victorian Child Care. Registering with us does not establish a solicitor client legal relationship
		with Shine Lawyers. No court proceedings have been filed and we may ultimately after investigations have
		concluded decide not to proceed with the case. As we have not entered into a solicitor client retainer with you
		at this time any rights you may have are not presently protected. Statutory time limits may also apply to your
		claim. If you have any concerns about your potential claim, please seek independent legal advice immediately.
	</p>
</FormRow>
